import { Component } from '@angular/core';
import { BasicList } from '../../../classes';
import { LoopBackConfig, LoopBackAuth, OtherOrderApi } from '../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { STORAGE_LOCATIONS, ORDER_STATUS, PAYMENT_TYPE, USER_ROLES } from '../../../enums';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { HasRolePipe } from '../../../pipes/has-role.pipe';

@Component({
  selector: 'app-other-orders',
  templateUrl: './other-orders.component.html',
  styleUrls: ['./other-orders.component.css']
})
export class OtherOrdersComponent extends BasicList {
  host:string = LoopBackConfig.getPath();
  container:string = STORAGE_LOCATIONS.PRODUCT_IMAGES;
  ORDER_STATUS: typeof ORDER_STATUS = ORDER_STATUS;
  PAYMENT_TYPE: typeof PAYMENT_TYPE = PAYMENT_TYPE;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'reference', placeholder: 'Reference Number' },
      { name: 'status', placeholder: 'Status', options: ORDER_STATUS },
      { name: 'orderId', placeholder: 'Order Id' },
      { name: 'ORNumber', placeholder: 'OR Number' },
      { name: 'failedAgentUsername', placeholder: 'Failed Agent Username', isBoolean: true },
      { name: 'failedShopStatusUpdate', placeholder: 'Failed To Update Shop', isBoolean: true },
      { name: 'failedGenerateOR', placeholder: 'Failed to Generate OR', isBoolean: true },
      { name: 'failedEmailOR', placeholder: 'Failed to Email OR via MVP', isBoolean: true }
    ],
    filters: {}
  };
  processing: {
    [key: string]: boolean
  } = {};

  constructor(
    private ordersApi: OtherOrderApi,
    private modalService: BsModalService,
    private otherOrderApi: OtherOrderApi,
    private loopBackAuth: LoopBackAuth,
    private toast: ToastrService,
    private hasRolePipe: HasRolePipe
  ) {
    super();
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.params = {
      where: {
        partnerId: this.getUser().partnerId
      },
      order: 'dateCreated DESC'
    };
    this.settings = {
      createComponent: undefined,
      api: this.ordersApi,
      ModalService: this.modalService
    };
  }

  resendOr(order: any) {
    if (!this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.TREASURY)) {
      return;
    }
    this.processing[order.id + '_or'] = true;
    this.otherOrderApi
      .resendOr(order.id)
      .pipe(finalize(() => {
        this.processing[order.id + '_or'] = false;
      }))
      .subscribe(data => {
        this.toast.success('OR sent to Member Viewpoint', 'Resend OR');
        this.getList();
      }, error => {
        this.toast.error(
          (error && error.message) ?
          (error.message.indexOf('Connection failed.') >= 0 ? 'Member viewpoint connection failed' : error.message) :
          ('Failed to resend OR of order ' + order.orderId), 'Resend OR');
      });
  }

  getOr(order: any) {
    if (
      !this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.TREASURY) ||
      order.status !== ORDER_STATUS.PAID ||
      (order.ORNumber && order.ORNumber !== '')
    ) {
      return;
    }
    this.processing[order.id + '_sap'] = true;
    this.otherOrderApi
      .generateOr(order.id)
      .pipe(finalize(() => {
        this.processing[order.id + '_sap'] = false;
      }))
      .subscribe(data => {
        if (data && data.ORNumber) {
          this.toast.success('OR successfully generated', 'Reprocess OR');
        } else {
          this.toast.error('Failed to generate OR of order ' + order.reference, 'Reprocess OR');
        }
        this.getList();
      }, error => {
        this.toast.error(
          (error && error.message) ?
          (error.message.indexOf('Connection failed.') >= 0 ? 'SAP connection failed' : error.message) :
          ('Failed to generate OR of order ' + order.orderId), 'Generate OR');
      });
  }

  resendStatus(order: any) {
    if (!this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.TREASURY)) {
      return;
    }
    this.processing[order.id + '_status'] = true;
    this.otherOrderApi
      .resendStatus(order.id)
      .pipe(finalize(() => {
        this.processing[order.id + '_status'] = false;
      }))
      .subscribe(data => {
        this.toast.success('Online Store successfully updated', 'Resend Status');
        this.getList();
      }, error => {
        this.toast.error(
          (error && error.message) ?
          (error.message.indexOf('Connection failed.') >= 0 ? 'Online store connection failed' : error.message) :
          ('Failed to resend Status of order ' + order.orderId), 'Resend Status');
      });
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}

